import { useState } from "react";

import { useCron, type CronString } from "./useCron";

export function useCurrentTime(cron: CronString = "@secondly") {
  const [now, setNow] = useState(() => new Date());
  useCron(cron, () => setNow(new Date()));
  return now;
}
